import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // P9-P0: initialise the i18n runtime before first render.
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
